export default __webpack_public_path__ + "static/media/relatedTaskIcon.aca3d493.svg";